// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"831185cc","369":"dc076e24","498":"98874801","703":"f53ef9df","845":"1e1ef1ab"}[chunkId] + ".chunk.js";
};